import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { testimonials } from '../data/content';
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-gris" data-id="element-143" data-mp="3ayi09lag3jqs">
      <div className="mx-auto max-w-3xl px-3 py-5 sm:px-4 sm:py-8" data-id="element-144" data-mp="3700p8qnwlp43">
        <SectionHeader id="testimonios" title="Lo que dicen quienes ya empezaron" description="De no saber por dónde comenzar a comprender cómo funciona una red completa." data-id="element-145" data-mp="3205zwrjs17l5" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-146" data-mp="2s28h4jkos2zx">
          {testimonials.map((t, i) => <li key={t.author} className={`flex flex-col rounded-xl border border-navy/10 bg-white p-2.5 sm:p-3 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-147" data-mp="v9ydd3vkvh6k" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-148" data-mp="h4n4wev9c5ci">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={13} aria-hidden="true" className="fill-amarillo text-amarillo" data-id="element-149" data-mp="780ivmr7388w" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-[0.78rem] leading-snug text-negro sm:text-sm" data-id="element-150" data-mp="c7n0e8e23ani">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-2 pt-2" data-id="element-151" data-mp="zx7rjekd5e7v">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-navy text-xs font-extrabold text-amarillo" data-id="element-152" data-mp="14uhfsqw0nju4">
                  {initials(t.author)}
                </span>
                <div className="min-w-0" data-id="element-153" data-mp="v4em0oh2m1uq">
                  <p className="text-sm font-extrabold text-navy" data-id="element-154" data-mp="1ivabvg1yumzc">{t.author}</p>
                  <p className="text-xs leading-tight text-negro/65" data-id="element-155" data-mp="1it7c44b0hfhf">{t.meta}</p>
                </div>
              </div>
            </li>)}
        </ul>
        <CtaBlock data-id="element-156" data-mp="1xgxzjb7do9my" />
      </div>
    </section>;
}